import { gql } from '@apollo/client';

export const getPoliciesList = gql`
  query searchPolicies(
    $pagination: PaginationInput!
    $selectedLines: [String!]
    $selectedSublines: [String!]
    $selectedPlans: [String!]
    $selectedBusinessPartners: [String!]
    $SelectedStatuses: [String!]
    $selectedOwners: [String!]
    $selectedTypes: [String!]
    $effectiveOnStart: DateTime
    $effectiveOnEnd: DateTime
    $issueDateStart: DateTime
    $issueDateEnd: DateTime
    $KeywordSearch: String
    $OrderBy: OrderByInput
  ) {
    production {
      searchPolicies(
        keyword: $KeywordSearch
        pagination: $pagination
        orderBy: $OrderBy
        statuses: $SelectedStatuses
        lines: $selectedLines
        sublines: $selectedSublines
        plans: $selectedPlans
        types: $selectedTypes
        businessPartners: $selectedBusinessPartners
        owners: $selectedOwners
        issueDateStart: $issueDateStart
        issueDateEnd: $issueDateEnd
        effectiveOnStart: $effectiveOnStart
        effectiveOnEnd: $effectiveOnEnd
      ) {
        items {
          id
          policyNumber
          line {
            code
            name
          }
          subline {
            code
            name
          }
          sublineCategory
          plan {
            code
            name
          }
          owner {
            person {
              fullName
            }
            typeList
            proposalID
            firstName
            middleName
            lastName
          }
          policyStatus
          policyIssueDate
          policyEffectiveDate
          policyExpiryDate
          paymentDivisionTotalNumber
          createdOn
        }
        paging {
          pageNumber
          pageSize
          totalCount
        }
      }
    }
  }
`;

export const getPolicyFilters = gql`
  query getPolicyFilters($lineIDs: [String!], $sublineIDs: [String!]) {
    production {
      getProposalLines {
        id
        code
        name
      }
      getProposalSublines(lineIDs: $lineIDs) {
        id
        code
        name
      }
      getProposalPlans(lineIDs: $lineIDs, sublineIDs: $sublineIDs) {
        id
        code
        name
      }
      getProposalBusinessPartners {
        id
        code
        fullName
      }
      getPolicyOwners {
        id
        firstName
        middleName
        lastName
      }
    }
    PolicyStatusList: __type(name: "PolicyStatusList") {
      enumValues {
        name
      }
    }
  }
`;

export const getPolicyById = gql`
  query getPolicyById($policyID: String!) {
    production {
      getPolicyDetails(id: $policyID) {
        clause
        code
        createdBy
        createdOn
        id
        isRenewal
        isRenewed
        isTransferred
        isReinsuranceTransferred
        lineID
        mainBusinessPartnerID
        modifiedBy
        modifiedOn
        name
        ownerID
        paymentDivisionFrequencyID
        paymentDivisionNumberReached
        paymentDivisionTotalNumber
        planID
        policyCurrencyID
        policyEffectiveDate
        policyExpiryDate
        policyIssueDate
        policyNumber
        policyStandardOption
        policyStatus
        policyType
        policyVersion
        policyVersionState
        proposalID
        relatedCompanyID
        renewalFromID
        renewalToID
        statusReason
        sublineCategory
        sublineID
        userID
        groupPolicy {
          policyNumber
          id
        }
        groupPolicyID
        line {
          abbreviation
          abbreviationArabic
          code
          createdBy
          createdOn
          id
          modifiedBy
          modifiedOn
          name
          nameArabic
          status
        }
        owner {
          assignedToBusinessPartnerID
          coverLimit
          createdBy
          createdOn
          id
          linkedBusinessPartnerID
          modifiedBy
          modifiedOn
          order
          personAddressID
          personID
          policyID
          policyVersion
          policyVersionState
          proposalID
          typeList
          person {
            fullName
            id
          }
        }
        mainBusinessPartner {
          auxiliaryAccount
          code
          createdBy
          createdOn
          fullName
          hasAccessToAllInsured
          id
          isCompany
          isLocal
          isRegistered
          maxCreditLimitAllowed
          maxCreditLimitAllowedCurrency
          modifiedBy
          modifiedOn
          personId
          registerationExpiryDate
          registerationNumber
          relatedCompany
          status
          taxAuxiliaryAccount
          totalCreditLimitReached
          type
        }
        paymentDivisionFrequency {
          code
          createdOn
          id
          modifiedOn
          title
        }
        plan {
          abbreviation
          acalCategoryEntity {
            id
            code
            title
          }
          sosService
          beneficiaryMaxNumber
          chargesPercentage
          code
          commissionAmount
          commissionAmountCurrency
          commissionApplicable
          commissionApplicableOn
          commissionRate
          commissionType
          createdBy
          createdOn
          effectiveFrom
          effectiveTo
          endorsementCost
          id
          insuredMaxNumber
          isEditableClause
          lineID
          maxTPA
          minTPA
          modifiedBy
          modifiedOn
          name
          nameArabic
          planCurrency
          policyCost
          scratching
          status
          sublineID
          tpaFeesAmount
          tpaFeesApplicableOn
          tpaFeesPercentage
          tpaFeesType
          replacementCarApplied
          replacementCarValue
          replacementCarDays
          grLimitDays
        }
        policyCurrency {
          code
          createdOn
          id
          modifiedOn
          status
          symbol
          title
          titleAr
        }
        relatedCompany {
          code
          createdOn
          externalCode
          id
          modifiedOn
          title
        }
        renewalFrom {
          id
          policyNumber
        }
        renewalTo {
          id
          policyNumber
        }
        subline {
          category
          code
          createdBy
          createdOn
          id
          lineID
          modifiedBy
          modifiedOn
          name
          nameArabic
          status
        }
        user {
          access
          accessFailedCount
          clauseEditRights
          code
          concurrencyStamp
          createdBy
          createdOn
          email
          emailConfirmed
          firstName
          groupPolicyEditRights
          id
          lastName
          lockoutEnabled
          lockoutEnd
          middleName
          modifiedBy
          modifiedOn
          normalizedEmail
          normalizedUserName
          passwordHash
          personId
          phoneNumber
          phoneNumberConfirmed
          planCoverEditRights
          policyEndDateEditRights
          securityStamp
          status
          twoFactorEnabled
          type
          userName
        }
        regenerateDocuments
        paymentDivisionFrequency {
          title
        }
        paymentDivisionNumberReached
        paymentDivisionTotalNumber
        proposal {
          id
          code
          name
        }
      }
    }
  }
`;

export const getPolicyMarineDetails = gql`
  query getPolicyMarineDetails($policyID: String!) {
    production {
      getPolicyPolicyMarine(policyID: $policyID) {
        id
        matter {
          id
          code
          title
        }
        description
        vessalName
        vessalAge
        departureFrom
        departureTo
        transportationVia
        survey
        cargoContract
        bank
        sumPerShipment
        sumPerShipmentCurrency {
          id
          code
          title
          status
          symbol
        }
        sumPerShipmentRate
        sumPerShipmentPolicyCurrency
        lcNumber
        lcIssueDate
        claimsPayableBy
        loading
        remarks
      }
    }
  }
`;

export const getPolicyPlanCovers = gql`
  query getPolicyPlanCovers($id: String!) {
    production {
      getPolicyPolicyPlanCovers(policyID: $id) {
        clauseID
        clauseIsEditable
        coverID
        createdBy
        createdOn
        effectiveFrom
        effectiveTo
        excessOnClaimAmount
        excessOnClaimDays
        excessOnClaimPercentage
        excessOnClaimType
        id
        isEditable
        isMain
        isMandatory
        modifiedBy
        modifiedOn
        planCoverID
        policyID
        policyPlanCoverParentID
        policyVersion
        policyVersionState
        premiumAmount
        premiumAmountArabic
        premiumAmountArabicLetters
        premiumAmountBasic
        premiumAmountSecondary
        premiumPercentage
        premiumType
        proposalID
        sumInsured
        sumInsuredArabic
        sumInsuredArabicLetters
        sumInsuredBasic
        sumInsuredIsAdditive
        sumInsuredSecondary
        clause {
          code
          createdBy
          createdOn
          description
          id
          lineID
          modifiedBy
          modifiedOn
          name
          status
        }
        cover {
          abbreviation
          abbreviationArabic
          code
          createdBy
          createdOn
          description
          id
          lineID
          modifiedBy
          modifiedOn
          name
          nameArabic
          printingOrder
        }
        planCover {
          clauseEditable
          clauseID
          coverID
          createdBy
          createdOn
          excessOnClaimAmount
          excessOnClaimDays
          excessOnClaimPercentage
          excessOnClaimType
          id
          isEditable
          isMain
          isMandatory
          modifiedBy
          modifiedOn
          planID
          premiumAmount
          premiumPercentage
          premiumType
          sumInsured
          sumInsuredIsAdditive
        }
      }
    }
  }
`;

export const getPolicyRiskDescription = gql`
  query getPolicyRiskDescription($policyID: String!) {
    production {
      getPolicyPolicyRiskDescription(policyID: $policyID) {
        order
        createdBy
        createdOn
        geoLocationID
        id
        modifiedBy
        modifiedOn
        policyID
        policyVersion
        policyVersionState
        proposalID
        riskDescription
        geoLocation {
          code
          createdOn
          id
          modifiedOn
          title
        }
      }
    }
  }
`;

export const getPolicyQuoteById = gql`
  query getPolicyQuoteById($id: String!) {
    production {
      getPolicyQuote(policyID: $id) {
        basicPremium
        basicPremiumBasic
        basicPremiumSecondary
        basicToPolicyRate
        chargesAmount
        chargesAmountBasic
        chargesAmountBeforeRounding
        chargesAmountSecondary
        chargesPercentage
        createdBy
        createdOn
        currencyID
        fixedStamp
        fixedStampAmount
        fixedStampAmountBasic
        fixedStampAmountSecondary
        fixedStampCurrencyID
        fixedStampToBasicRate
        fixedStampToPolicyRate
        grossPremium
        grossPremiumBasic
        grossPremiumBeforeRounding
        grossPremiumSecondary
        id
        modifiedBy
        modifiedOn
        municipalityTax
        municipalityTaxAmount
        municipalityTaxAmountBasic
        municipalityTaxAmountSecondary
        municipalityTaxBeforeRounding
        netPremium
        netPremiumBasic
        netPremiumSecondary
        planToBasicRate
        planToPolicyRate
        policyCost
        policyCostBasic
        policyCostSecondary
        policyID
        policyToSecondaryRate
        policyVersion
        policyVersionState
        proportionalStamp
        proportionalStampAmount
        proportionalStampAmountBasic
        proportionalStampAmountSecondary
        proportionalStampBeforeRounding
        proposalID
        reinsuranceTax
        reinsuranceTaxAmount
        roundingDifference
        status
        sumInsured
        sumInsuredArabic
        sumInsuredArabicLetters
        sumInsuredBasic
        sumInsuredBeforeLoading
        sumInsuredLetters
        sumInsuredSecondary
        taxOnCommission
        taxOnCommissionAmount
        taxOnCommissionAmountBasic
        taxOnCommissionAmountSecondary
        totalCommission
        totalCommissionBasic
        totalCommissionSecondary
        totalPremium
        totalPremiumArabic
        totalPremiumArabicLetters
        totalPremiumBasic
        totalPremiumBeforeRounding
        totalPremiumLetters
        totalPremiumSecondary
        tpaFeesAmount
        tpaFeesApplicableOn
        tpaFeesPercentage
        tpaFeesTotalAmount
        tpaFeesTotalAmountBasic
        tpaFeesTotalAmountSecondary
        tpaFeesType
        finalDiscount
        currency {
          code
          createdOn
          id
          modifiedOn
          status
          symbol
          title
          titleAr
        }
      }
    }
  }
`;

export const getPolicyBBBDetails = gql`
  query getPolicyBBBDetails($policyID: String!) {
    production {
      getPolicyPolicyBankersBlanketBondsDetails(policyID: $policyID) {
        id
        branchName
        isMain
        isAgency
        employeeNumber
        underwritingYear
        infedility
        burglary
        holdup
        inSafe
        inTransit
        forgedCheques
        counterfeitCurrencies
        clause6
        falsification
      }
    }
  }
`;

export const getPolicyMarineHull = gql`
  query getPolicyMarineHull($policyID: String!) {
    production {
      getPolicyPolicyMarineHull(policyID: $policyID) {
        id
        vesselName
        connectionPort
        territorialWaters
        usage
        builder
        constructionYear
        registryPort
        length
        weight
        height
        engineType
        engineNumber
        engineYearBuilt
        engineHorsePower
        engineMaxDesignedSpeed
        engineFuel
        remarks
      }
    }
  }
`;

export const getGeoLocations = gql`
  query getGeoLocations {
    production {
      getGeoLocations {
        id
        code
        title
      }
    }
  }
`;

export const getPolicyProperty = gql`
  query getPolicyProperty($policyID: String!) {
    production {
      getPolicyPolicyProperty(policyID: $policyID) {
        id
        order
        riskDescription
        geoLocationID
        geoLocation {
          id
          code
          title
        }
        location
        planCoverPropertyDetails {
          planCoverID
          riskRate
          sumInsured
          premium
        }
      }
    }
  }
`;

export const getPropertyDescriptionLovs = gql`
  query getPropertyDescriptionLovs($planID: String!) {
    production {
      getGeoLocations {
        id
        code
        title
      }
    }

    planConfig {
      getPlanPlanCovers(
        planID: $planID
        pagination: { pageNumber: 1, pageSize: 1000000 }
      ) {
        items {
          id
          cover {
            id
            name
            code
          }
        }
      }
    }
  }
`;

export const getPolicyPersons = gql`
  query getPolicyPersons($policyID: String!) {
    production {
      getPolicyPolicyPersons(policyID: $policyID) {
        id
        isPrincipal
        policyVersionState
        typeList
        coverLimit
        cardNumber
        tpaReference1
        tpaReference2
        continuity
        grLimitDays
        exclusions
        remarks
        dateOfBirth
        passportNumber
        phoneNumber
        address {
          addressDetails
          city
        }
        dangerousActivity
        firstName
        middleName
        lastName
        nationality {
          code
          title
        }
        person {
          id
          gender
          code
          dateOfBirth
          phoneDetails {
            phoneType
            phoneNumber
          }
          fullName
          isTaxable
          firstNationality {
            title
            code
          }
          occupation {
            id
            code
            title
          }
          passportNumber
          profession
          type
          smoker
          relation
        }
        personAddress {
          addressType
          country {
            id
            code
            title
          }
          address {
            country
            zone
            city
            street
            building
            addressDetails
            addressDetailsArabic
          }
        }
        relation
        beneficiaryPercentage
      }
    }
  }
`;
export const getPolicyBusinessPartners = gql`
  query getPolicyBusinessPartners(
    $policyID: String!
    $orderBy: OrderByInput
    $keyword: String!
  ) {
    production {
      getPolicyPolicyBusinessPartners(
        policyID: $policyID
        orderBy: $orderBy
        keyword: $keyword
      ) {
        id
        businessPartner {
          personId
          fullName
        }
        isPrimary
        sharePercentage
        planCommissionType
        planCommissionAmount
        planCommissionCurrencyID
        planCommissionCurrency {
          symbol
          id
        }
        planCommissionRate
        planCommissionApplicableOn {
          title
          id
        }
        commissionAmount
        policyShareCommissionAmount
        taxOnCommission
        taxOnCommissionAmount
        businessPartnerID
      }
    }
  }
`;

export const getPolicyDocuments = gql`
  query getPolicyDocuments($policyID: String!) {
    production {
      getPolicyDocuments(policyID: $policyID) {
        documentName
        version
        documentId
        createdOn
        fileName
        documentName
        documentType
        contentType
        length
      }
    }
  }
`;

export const getAdditionalPolicyDocuments = gql`
  query getAdditionalPolicyDocuments($policyID: String!) {
    production {
      getAdditionalPolicyDocuments(policyID: $policyID) {
        documentName
        version
        documentId
        createdOn
        fileName
        documentName
        documentType
        contentType
        length
      }
    }
  }
`;

export const getUserAssignedLines = gql`
  query getUserAssignedLines(
    $pagination: PaginationInput!
    $selectedUserID: String!
    $OrderBy: OrderByInput!
    $keywordSearch: String
  ) {
    salesforce {
      searchUserAssignedLines(
        pagination: $pagination
        userID: $selectedUserID
        orderBy: $OrderBy
        keyword: $keywordSearch
      ) {
        paging {
          pageSize
          pageNumber
          totalCount
        }
        items {
          createdBy
          createdOn
          id
          lineID
          modifiedBy
          modifiedOn
          status
          userID
          line {
            abbreviation
            abbreviationArabic
            code
            createdBy
            createdOn
            id
            modifiedBy
            modifiedOn
            name
            nameArabic
            status
          }
          user {
            access
            accessFailedCount
            code
            concurrencyStamp
            createdBy
            createdOn
            email
            emailConfirmed
            firstName
            id
            lastName
            lockoutEnabled
            lockoutEnd
            middleName
            modifiedBy
            modifiedOn
            normalizedEmail
            normalizedUserName
            passwordHash
            personId
            phoneNumber
            phoneNumberConfirmed
            securityStamp
            status
            twoFactorEnabled
            type
            userName
          }
        }
      }
    }
  }
`;

export const searchPolicyPayments = gql`
  query searchPolicyPayments(
    $policyID: String!
    $keyword: String!
    $pageNumber: Int!
    $pageSize: Int!
    $orderAttribute: String!
    $orderDescending: Boolean!
  ) {
    production {
      searchPolicyPayments(
        policyID: $policyID
        keyword: $keyword
        pagination: { pageNumber: $pageNumber, pageSize: $pageSize }
        orderBy: { attribute: $orderAttribute, descending: $orderDescending }
      ) {
        items {
          id
          number
          referenceNumber
          issueDate
          nextIssueDate
          periodFrom
          periodTo
          policyID
          policyCurrencyID
          totalPremium
          totalPremiumBasic
          totalPremiumSecondary
          totalPremiumBeforeRounding
          totalPremiumArabic
          totalPremiumArabicLetters
          totalPremiumReceived
          totalPremiumBalance
          totalCommission
          totalCommissionBasic
          totalCommissionSecondary
          totalCommissionPaid
          totalCommissionBalance
          taxOnCommissionAmount
          taxOnCommissionAmountBasic
          taxOnCommissionAmountSecondary
          basicPremium
          basicPremiumBasic
          basicPremiumSecondary
          basicToPolicyRate
          netPremium
          netPremiumBasic
          netPremiumSecondary
          grossPremium
          grossPremiumBasic
          grossPremiumSecondary
          grossPremiumBeforeRounding
          chargesAmount
          chargesAmountBasic
          chargesAmountSecondary
          chargesAmountBeforeRounding
          chargesPercentage
          policyCost
          policyCostBasic
          policyCostSecondary
          proportionalStampAmount
          proportionalStampAmountBasic
          proportionalStampAmountSecondary
          proportionalStampBeforeRounding
          fixedStampAmount
          fixedStampAmountBasic
          fixedStampAmountSecondary
          municipalityTaxAmount
          municipalityTaxAmountBasic
          municipalityTaxAmountSecondary
          municipalityTaxBeforeRounding
          reinsuranceTax
          reinsuranceTaxAmount
          tpaFeesTotalAmount
          tpaFeesTotalAmountBasic
          tpaFeesTotalAmountSecondary
          planToBasicRate
          planToPolicyRate
          policyToSecondaryRate
          roundingDifference
          createdBy
          createdOn
          modifiedBy
          modifiedOn
          frequencyID
          policyQuoteID
          policyCurrency {
            code
            createdOn
            id
            modifiedOn
            status
            symbol
            title
            titleAr
          }
        }
        paging {
          pageNumber
          pageSize
          totalCount
        }
      }
    }
  }
`;

export const getPolicyPaymentsTravel = gql`
  query getPolicyPaymentsTravel($policyID: String!) {
    production {
      GetPolicyPayments(policyID: $policyID) {
        policyDues {
          number
          dueDate
          policyPayment {
            policyCurrency {
              id
              symbol
            }
            totalPremium
          }
          amountDue
          amountPaid
          outstandingBalance
          status
        }
      }
    }
  }
`;

export const searchCertificatePayments = gql`
  query searchCertificatePayments(
    $policyID: String!
    $keyword: String!
    $pageNumber: Int!
    $pageSize: Int!
    $orderAttribute: String!
    $orderDescending: Boolean!
  ) {
    production {
      searchCertificatePayments(
        groupPolicyId: $policyID
        keyword: $keyword
        pagination: { pageNumber: $pageNumber, pageSize: $pageSize }
        orderBy: { attribute: $orderAttribute, descending: $orderDescending }
      ) {
        items {
          id
          policyID
          referenceNumber
          totalPremium
          totalPremiumReceived
          totalPremiumBalance
          totalCommission
          totalCommissionPaid
          totalCommissionBalance
          taxOnCommissionAmount
          policyCurrency {
            symbol
          }
        }
        paging {
          pageNumber
          pageSize
          totalCount
        }
      }
    }
  }
`;

export const getPolicyExpat = gql`
  query getPolicyExpat($policyID: String!) {
    production {
      getPolicyPolicyExpat(policyID: $policyID) {
        id
        gender
        dateOfBirth
        nationality {
          id
          code
          title
        }
        occupationClass {
          id
          code
          title
        }
        medicalClass {
          id
          code
          title
        }
        emergency
        continuity
        continuityNumber
        exclusion
        remarks
      }
    }
  }
`;

export const getPolicyMotor = gql`
  query getPolicyMotor($policyID: String!) {
    production {
      getPolicyPolicyMotor(policyID: $policyID) {
        id
        nameOnLicenseEN
        nameOnLicenseAR
        vignetteCode
        vignette
        agencyRepairYears
        depreciationYears
        vehicle {
          carValue
          plateCode {
            id
            code
            title
          }
          plateNumber
          usageType {
            id
            code
            title
          }
          bodyType {
            id
            code
            title
          }
          engineType {
            id
            code
            title
          }
          make {
            id
            code
            title
          }
          model {
            id
            code
            title
          }
          color {
            id
            code
            title
          }
          yearOfMake
          engine
          weight
          engineSize
          seatingCapacity
          chassis
          horsePower
        }
      }
    }
  }
`;

export const getPolicyMedical = gql`
  query getPolicyMedical($policyID: String!) {
    production {
      getPolicyPolicyMedical(policyID: $policyID) {
        medicalClassId
        levelId
        nssf
      }
    }
  }
`;

export const getMotorModelLovs = gql`
  query getMotorModelLovs($makeID: String!) {
    core {
      getModelList(makeID: $makeID) {
        id
        code
        title
      }
    }
  }
`;

export const getMotorLovs = gql`
  query getMotorLovs {
    core {
      getPlateCodeList {
        id
        code
        title
      }
      getUsageTypeList {
        id
        code
        title
      }
      getBodyTypeList {
        id
        code
        title
      }
      getEngineTypeList {
        id
        code
        title
      }
      getMakeList {
        id
        code
        title
      }
      getColorList {
        id
        code
        title
      }
    }
  }
`;

export const validateVignette = gql`
  query validateVignette($input: ValidateVignetteInput!) {
    production {
      validateVignette(input: $input) {
        rangeFrom
        rangeTo
      }
    }
  }
`;

export const validateVignetteExist = gql`
  query validateProposalVignette($input: ValidateProposalVignetteInput!) {
    production {
      validateProposalVignette(input: $input) {
        id
        policyID
      }
    }
  }
`;

export const getPolicyTravel = gql`
  query getPolicyTravel($policyID: String!) {
    production {
      getPolicyPolicyTravel(policyID: $policyID) {
        travelDestination {
          code
          id
          title
        }
        destination {
          code
          id
          title
        }
        duration
        tripType
      }
    }
  }
`;

export const getPolicyPremiumDetails = gql`
  query getPolicyInsuredPolicyQuoteMedicalGroupByPolicyPerson(
    $policyID: String!
    $pagination: PaginationInput!
    $keyword: String
    $orderBy: OrderByInput!
  ) {
    production {
      getPolicyInsuredPolicyQuoteMedicalGroupByPolicyPerson(
        policyID: $policyID
        pagination: $pagination
        keyword: $keyword
        orderBy: $orderBy
      ) {
        items {
          sumInsured
          age
          netPremium
          charges
          tpaFees
          grossPremium
          proportionalStamps
          municipalityTax
          totalPremium
          policyPerson {
            person {
              code
              fullName
            }
            relation
          }
        }
      }
    }
  }
`;

export const getPolicyTravelPremiumDetails = gql`
  query getPolicyTravelPremiumDetails(
    $policyID: String!
    $pagination: PaginationInput!
    $keyword: String
    $orderBy: OrderByInput!
  ) {
    production {
      getPolicyInsuredPolicyQuoteTravelGroupByPolicyPerson(
        policyID: $policyID
        pagination: $pagination
        keyword: $keyword
        orderBy: $orderBy
      ) {
        items {
          sumInsured
          age
          netPremium
          charges
          tpaFees
          grossPremium
          proportionalStamps
          municipalityTax
          totalPremium
          policyPerson {
            person {
              code
              fullName
            }
            firstName
            middleName
            lastName
            relation
          }
        }
      }
    }
  }
`;

export const downloadPolicyMedicalPremiumDetails = gql`
  query downloadPolicyInsuredPolicyQuoteMedical($policyID: String!) {
    production {
      downloadPolicyInsuredPolicyQuoteMedical(policyID: $policyID) {
        content
        contentType
        fileName
      }
    }
  }
`;

export const downloadPolicyTravelPremiumDetails = gql`
  query downloadPolicyInsuredPolicyQuoteTravel($policyID: String!) {
    production {
      downloadPolicyInsuredPolicyQuoteTravel(policyID: $policyID) {
        content
        contentType
        fileName
      }
    }
  }
`;

export const getPolicyGroupMedicalCertificates = gql`
  query getPolicyCertificatePaginated(
    $pagination: PaginationInput!
    $orderBy: OrderByInput
    $policyID: String!
    $keyword: String
  ) {
    production {
      getPolicyCertificatePaginated(
        pagination: $pagination
        orderBy: $orderBy
        policyID: $policyID
        keyword: $keyword
      ) {
        items {
          certificateID
          certificateNumber
          principal
          numberOfAdherent
          class
          level
          coNSSF
          sumInsured
          netPremium
          charges
          tpaFees
          grossPremium
          proportionalStamp
          municipalityTax
          totalPremium
        }
        paging {
          pageNumber
          pageSize
          totalCount
        }
      }
    }
  }
`;

export const getPolicyFleetCertificates = gql`
  query getFleetCertificatePaginated(
    $pagination: PaginationInput!
    $orderBy: OrderByInput
    $policyID: String!
    $keyword: String
  ) {
    production {
      groupFleetCertificatesForListing(
        pagination: $pagination
        orderBy: $orderBy
        groupPolicyId: $policyID
        search: $keyword
      ) {
        paging {
          pageNumber
          pageSize
          totalCount
        }
        items {
          policy {
            id
            policyNumber
            policyEffectiveDate
            lineID
            policyType
            groupPolicyID

            subline {
              id
              code
              name
            }
            plan {
              id
              code
              name
            }
          }

          policyMotor {
            agencyRepairYears
            depreciationYears
            replacementCarValue
          }

          vehicle {
            plateNumber
            plateCode {
              id
              code
              title
            }
            make {
              id
              title
            }
            model {
              id
              title
            }
            yearOfMake
            chassis
            carValue
          }

          quote {
            currency {
              id
              code
              title
            }
            sumInsured
            netPremium
            chargesAmount
            tpaFeesTotalAmount
            grossPremium
            proportionalStampAmount
            municipalityTaxAmount
            totalPremium
          }
        }
      }
    }
  }
`;

export function calculateBasicRate() {
  return gql`
    mutation calculateBasicRate($currency: String!) {
      core {
        CalculateBasicRate(currencyID: $currency)
      }
    }
  `;
}

export const searchPolicyPaymentsQuery = gql`
  query searchPolicyPayments(
    $policyID: String!
    $keyword: String!
    $pageNumber: Int!
    $pageSize: Int!
    $orderAttribute: String!
    $orderDescending: Boolean!
  ) {
    production {
      searchPolicyPayments(
        policyID: $policyID
        keyword: $keyword
        pagination: { pageNumber: $pageNumber, pageSize: $pageSize }
        orderBy: { attribute: $orderAttribute, descending: $orderDescending }
      ) {
        items {
          id
          number
          referenceNumber
          issueDate
          nextIssueDate
          periodFrom
          periodTo
          policyID
          policyCurrencyID
          totalPremium
          totalPremiumBasic
          totalPremiumSecondary
          totalPremiumBeforeRounding
          totalPremiumArabic
          totalPremiumArabicLetters
          totalPremiumReceived
          totalPremiumBalance
          totalCommission
          totalCommissionBasic
          totalCommissionSecondary
          totalCommissionPaid
          totalCommissionBalance
          taxOnCommissionAmount
          taxOnCommissionAmountBasic
          taxOnCommissionAmountSecondary
          basicPremium
          basicPremiumBasic
          basicPremiumSecondary
          basicToPolicyRate
          netPremium
          netPremiumBasic
          netPremiumSecondary
          grossPremium
          grossPremiumBasic
          grossPremiumSecondary
          grossPremiumBeforeRounding
          chargesAmount
          chargesAmountBasic
          chargesAmountSecondary
          chargesAmountBeforeRounding
          chargesPercentage
          policyCost
          policyCostBasic
          policyCostSecondary
          proportionalStampAmount
          proportionalStampAmountBasic
          proportionalStampAmountSecondary
          proportionalStampBeforeRounding
          fixedStampAmount
          fixedStampAmountBasic
          fixedStampAmountSecondary
          municipalityTaxAmount
          municipalityTaxAmountBasic
          municipalityTaxAmountSecondary
          municipalityTaxBeforeRounding
          reinsuranceTax
          reinsuranceTaxAmount
          tpaFeesTotalAmount
          tpaFeesTotalAmountBasic
          tpaFeesTotalAmountSecondary
          planToBasicRate
          planToPolicyRate
          policyToSecondaryRate
          roundingDifference
          createdBy
          createdOn
          modifiedBy
          modifiedOn
          frequencyID
          policyQuoteID
          policyCurrency {
            code
            createdOn
            id
            modifiedOn
            status
            symbol
            title
            titleAr
          }
        }
        paging {
          pageNumber
          pageSize
          totalCount
        }
      }
    }
  }
`;

export const getPersonLovsQuery = gql`
  query getPersonLovsQuery {
    core {
      getNationalities {
        id
        title
      }
      getCountries {
        id
        title
      }
      getZones {
        id
        title
      }
      getOccupationClass {
        id
        code
        title
      }
    }
    RelationsList: __type(name: "RelationsList") {
      enumValues {
        name
      }
    }

    ContinuityList: __type(name: "ContinuityList") {
      enumValues {
        name
      }
    }
    PhoneType: __type(name: "PhoneType") {
      name
      enumValues {
        name
      }
    }
    Gender: __type(name: "Gender") {
      name
      enumValues {
        name
      }
    }
  }
`;

export const searchPoliciesForRenewals = gql`
  query searchPoliciesForRenewals(
    $pagination: PaginationInput!
    $keyword: String
    $orderBy: OrderByInput
  ) {
    production {
      searchPoliciesForRenewals(
        pagination: $pagination
        keyword: $keyword
        orderBy: $orderBy
      ) {
        items {
          id
          policyNumber
          line {
            id
            code
          }
          subline {
            id
            code
          }
          plan {
            id
            code
            planCurrency
          }
          policyExpiryDate
        }
      }
    }
  }
`;

export const getExportPoliciesLOVs = gql`
  query GetExportPoliciesLOVs {
    PolicyStatusList: __type(name: "PolicyStatusList") {
      enumValues {
        name
      }
    }
    production {
      getPolicyOwners {
        id
        firstName
        middleName
        lastName
      }
      getProposalBusinessPartners {
        id
        code
        fullName
      }
    }
    core {
      getCurrencies {
        id
        code
        title
      }
    }
  }
`;

export const searchPoliciesForExport = gql`
  query searchPoliciesForExport(
    $currentPage: Int!
    $currentPageSize: Int!
    $selectedOwners: [String!]
    $selectedBusinessPartners: [String!]
    $selectedStatuses: [String!]
    $effectiveOnStart: DateTime
    $effectiveOnEnd: DateTime
    $expiryOnStart: DateTime
    $expiryOnEnd: DateTime
    $issueDateStart: DateTime
    $issueDateEnd: DateTime
    $createdOnStart: DateTime
    $createdOnEnd: DateTime
    $Attribute: String!
    $Descending: Boolean!
  ) {
    production {
      searchPolicies(
        pagination: { pageNumber: $currentPage, pageSize: $currentPageSize }
        orderBy: { attribute: $Attribute, descending: $Descending }
        owners: $selectedOwners
        businessPartners: $selectedBusinessPartners
        statuses: $selectedStatuses
        effectiveOnStart: $effectiveOnStart
        effectiveOnEnd: $effectiveOnEnd
        expiryOnStart: $expiryOnStart
        expiryOnEnd: $expiryOnEnd
        issueDateStart: $issueDateStart
        issueDateEnd: $issueDateEnd
        createdOnStart: $createdOnStart
        createdOnEnd: $createdOnEnd
      ) {
        paging {
          pageNumber
          pageSize
          totalCount
        }
        items {
          policyNumber
          plan {
            code
            name
          }
          user {
            code
            firstName
            middleName
            lastName
          }
          mainBusinessPartner {
            code
            fullName
          }
          policyEffectiveDate
          policyExpiryDate
          policyIssueDate
          policyCurrency {
            title
          }
          isRenewal
          renewalFrom {
            policyNumber
          }
          isRenewed
          renewalTo {
            policyNumber
          }
          policyStatus
          statusReason
        }
      }
    }
  }
`;
